var _style, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _polygon2, _polygon3, _rect46, _rect47, _polygon4, _polygon5, _rect48, _rect49, _rect50, _rect51, _rect52, _path, _path2, _polygon6, _path3, _rect53, _rect54, _rect55, _rect56, _rect57, _path4, _circle, _circle2, _circle3, _circle4, _polygon7, _polygon8, _rect58, _rect59, _path5, _path6, _polygon9, _polygon10, _polygon11, _path7, _path8, _path9, _rect60, _path10, _circle5, _circle6, _circle7, _circle8, _polygon12, _polygon13, _rect61, _rect62, _path11, _path12, _polygon14, _polygon15, _polygon16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerkehrsrechtAbstandsverstoss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 888.5 744",
    style: {
      enableBackground: "new 0 0 888.5 744"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F3D56;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#CCCCCC;}\n\t.st4{fill:#137F7B;}\n\t.st5{fill:#F2F2F2;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "632.7,121.8 554,121.8 554,50.3 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 119.5,
    className: "st1",
    width: 396,
    height: 547
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 285.4,
    y: 157.9,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 357.5,
    y: 157.9,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 297,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 357.5,
    y: 297,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 425.7,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 355.7,
    y: 424,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 423.4,
    y: 568.6,
    className: "st3",
    width: 46.6,
    height: 98.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 424,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 424,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 495.6,
    y: 295.9,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 573.7,
    y: 295.9,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 495.6,
    y: 157.9,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 573.7,
    y: 157.9,
    className: "st2",
    width: 46.6,
    height: 98.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 245.9,
    className: "st0",
    width: 396,
    height: 15
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 362.4,
    className: "st0",
    width: 396,
    height: 8.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 335.8,
    className: "st0",
    width: 396,
    height: 8.3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 276.7,
    y: 463.9,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 323.3,
    y: 463.9,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 369.9,
    y: 463.9,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 416.4,
    y: 463.9,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 463,
    y: 463.9,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 509.6,
    y: 463.9,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 556.2,
    y: 463.9,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 602.8,
    y: 463.9,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 337.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 324.1,
    y: 337.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 337.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 417.3,
    y: 337.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 463.9,
    y: 337.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 510.4,
    y: 337.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 337.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 603.6,
    y: 337.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 189.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 324.1,
    y: 189.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 189.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 417.3,
    y: 189.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 463.9,
    y: 189.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 510.4,
    y: 189.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 189.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 603.6,
    y: 189.4,
    className: "st0",
    width: 8.3,
    height: 66.5
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 212.7,
    className: "st0",
    width: 396,
    height: 8.3
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 186.1,
    className: "st0",
    width: 396,
    height: 8.3
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 390.7,
    className: "st0",
    width: 396,
    height: 15
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 227.7,
    y: 113.4,
    className: "st0",
    width: 432.4,
    height: 22.3
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "332.1,589.8 332.1,568.6 306.6,568.6 306.6,589.8 330,589.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "330,606.8 306.6,606.8 306.6,628 332.1,628 332.1,606.8 "
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 349.1,
    y: 568.6,
    className: "st2",
    width: 25.5,
    height: 21.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 349.1,
    y: 606.8,
    className: "st2",
    width: 25.5,
    height: 21.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "539.8,589.8 539.8,568.6 514.4,568.6 514.4,589.8 537.7,589.8 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "537.7,606.8 514.4,606.8 514.4,628 539.8,628 539.8,606.8 "
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 556.8,
    y: 568.6,
    className: "st2",
    width: 25.5,
    height: 21.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 556.8,
    y: 606.8,
    className: "st2",
    width: 25.5,
    height: 21.2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 517.1,
    className: "st0",
    width: 396,
    height: 15
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 490.5,
    className: "st0",
    width: 396,
    height: 8.3
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 463.9,
    className: "st0",
    width: 396,
    height: 8.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M365.8,659.4c0-0.5,0-0.9,0-1.4c-0.4-12.3-12.5-15.6-19-9.8c-4.3-3.7-10.6-3.7-14.8,0 c-6.5-5.7-18.5-2.6-18.9,9.5c0,0.5,0,0.9,0,1.4c0,2.5,0.2,5.1,0.5,7.6h51.9C365.6,664.3,365.8,661.9,365.8,659.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M571.9,659.4c0-0.5,0-0.9,0-1.4c-0.4-12.3-12.5-15.6-19-9.8c-4.3-3.7-10.6-3.7-14.8,0 c-6.5-5.7-18.5-2.6-18.9,9.5c0,0.5,0,0.9,0,1.4c0,2.5,0.2,5.1,0.5,7.6h51.9C571.7,664.3,571.9,661.9,571.9,659.4z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "856.3,667.6 848.3,667.6 851,510.9 853.6,510.9 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M863,412.3l12.9-20c-3.8-10.6-8.3-21-13.3-31.1l-8.4,6.8l6.6-10.2c-6.3-12.4-11.3-20.3-11.3-20.3 s-26,40.9-34.6,84.2l16.6,25.7l-18.4-14.9c-0.7,5-1,10.1-1,15.2c0,51.3,16.8,92.9,37.4,92.9c20.7,0,37.4-41.6,37.4-92.9 c0-15.9-3.6-32.5-8.6-47.9L863,412.3z"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 459.9,
    y: 717.5,
    className: "st1",
    width: 151.8,
    height: 6
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 735.9,
    y: 717.5,
    className: "st1",
    width: 152.6,
    height: 6
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 183.9,
    y: 717.5,
    className: "st1",
    width: 152,
    height: 6
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    y: 666.6,
    className: "st0",
    width: 887.9,
    height: 1.7
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 696.4,
    y: 692.7,
    className: "st0",
    width: 17.9,
    height: 2.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M567.2,693.3l3.7,0.9l140.2,0.1l1.3-2.9c2.2-5,3-10.6,2.2-16c-0.6-4.1-2.1-8.1-5.6-9.8l-6.2-41.4l-77.5-0.1 l-30,24.2c0,0-14.2-0.3-21.8,9.3c-2.8,3.6-4.4,7.9-4.7,12.4l-0.3,5L567.2,693.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 597.9,
    cy: 692.6,
    r: 17.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 597.9,
    cy: 692.6,
    r: 9.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 683.3,
    cy: 692.7,
    r: 17.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 683.3,
    cy: 692.7,
    r: 9.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "607,645.2 648.9,645.3 654,645.3 662.7,645.3 662.7,644.6 662.7,637.1 662.7,628.5 656.9,628.5  651.8,628.5 642.8,628.5 637.6,628.5 627.2,628.5 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "669.5,645.3 691.6,645.3 691.6,640.9 691.6,633.4 691.6,628.5 688.4,628.5 683.3,628.5 669.5,628.5 "
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 659.8,
    y: 657.8,
    className: "st0",
    width: 2.8,
    height: 5.4
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 650.1,
    className: "st0",
    width: 5.4,
    height: 2.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.4,651.3l-0.3,0c-3.3,0-5.9-2.7-5.9-5.9l0,0c0-3.3,2.7-5.9,5.9-5.9l0.3,0l0,0L616.4,651.3L616.4,651.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M568.3,674.7c5,0.5,9.6-3.1,10.1-8.1c0.4-3.8-1.6-7.5-5.1-9.2c-2.8,3.6-4.4,7.9-4.7,12.4L568.3,674.7z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "651.8,628.5 662.7,644.6 662.7,637.1 656.9,628.5 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "683.3,628.5 691.6,640.9 691.6,633.4 688.4,628.5 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "637.6,628.5 648.9,645.3 654,645.3 642.8,628.5 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.4,1l-0.1,0.1c-2.5,1.4-5.6,1.4-8.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2.5-1.4-5.6-1.3-8.1,0l-0.1,0.1 c-2.5,1.4-5.6,1.4-8.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2.5-1.4-5.5-1.4-8.1,0c-3.8,2-8.9,5.5-8.9,9.5c0,0.2,0,0.3,0,0.5 c0.4,4.1,13.8,5.1,21.1,3.2c5.5,1.2,11.2,1.2,16.6,0c7.3,2,20.9,0.8,21.3-3.3c0-0.2,0-0.3,0-0.5c0-3.9-5.2-7.4-9-9.4 C415.9-0.4,412.9-0.3,410.4,1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M778.4,136.3l-0.1,0.1c-2.5,1.4-5.6,1.4-8.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2.5-1.4-5.6-1.3-8.1,0l-0.1,0.1 c-2.5,1.4-5.6,1.4-8.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2.5-1.4-5.5-1.4-8.1,0c-3.8,2-8.9,5.5-8.9,9.5c0,0.2,0,0.3,0,0.5 c0.4,4.1,13.8,5.1,21.1,3.2c5.5,1.2,11.2,1.2,16.6,0c7.3,2,20.9,0.8,21.3-3.3c0-0.2,0-0.3,0-0.5c0-3.9-5.2-7.4-9-9.4 C783.9,134.9,780.9,134.9,778.4,136.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,143.8l-0.1,0.1c-2.5,1.4-5.6,1.4-8.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2.5-1.4-5.6-1.3-8.1,0l-0.1,0.1 c-2.5,1.4-5.6,1.4-8.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2.5-1.4-5.5-1.4-8.1,0c-3.8,2-8.9,5.5-8.9,9.5c0,0.2,0,0.3,0,0.5 c0.4,4.1,13.8,5.1,21.1,3.2c5.5,1.2,11.2,1.2,16.6,0c7.3,2,20.9,0.8,21.3-3.3c0-0.2,0-0.3,0-0.5c0-3.9-5.2-7.4-9-9.4 C139.5,142.4,136.5,142.4,134,143.8z"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 525.5,
    y: 691.8,
    className: "st0",
    width: 17.9,
    height: 2.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M396.2,692.5l3.7,0.9l140.2,0.1l1.3-2.9c2.2-5,3-10.6,2.2-16c-0.6-4.1-2.1-8.1-5.6-9.8l-6.2-41.4l-77.5-0.1 l-30,24.2c0,0-14.2-0.3-21.8,9.3c-2.8,3.6-4.4,7.9-4.7,12.4l-0.3,5L396.2,692.5z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 427,
    cy: 691.8,
    r: 17.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 427,
    cy: 691.8,
    r: 9.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 512.4,
    cy: 691.8,
    r: 17.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 512.4,
    cy: 691.8,
    r: 9.1
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "436.1,644.4 478,644.4 483.1,644.4 491.7,644.4 491.7,643.8 491.7,636.2 491.7,627.7 486,627.7  480.9,627.7 471.8,627.7 466.7,627.7 456.3,627.7 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "498.5,644.4 520.7,644.5 520.7,640.1 520.7,632.5 520.7,627.7 517.4,627.7 512.3,627.7 498.5,627.7 "
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 488.9,
    y: 656.9,
    className: "st0",
    width: 2.8,
    height: 5.4
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 442.1,
    y: 649.2,
    className: "st0",
    width: 5.4,
    height: 2.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445.5,650.5l-0.3,0c-3.3,0-5.9-2.7-5.9-5.9l0,0c0-3.3,2.7-5.9,5.9-5.9l0.3,0l0,0L445.5,650.5L445.5,650.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.3,673.9c5,0.5,9.6-3.1,10.1-8.1c0.4-3.8-1.6-7.5-5.1-9.2c-2.8,3.6-4.4,7.9-4.7,12.4L397.3,673.9z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "480.9,627.7 491.7,643.8 491.7,636.2 486,627.7 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "512.3,627.7 520.7,640.1 520.7,632.5 517.4,627.7 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "466.7,627.7 478,644.4 483.1,644.4 471.8,627.7 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkehrsrechtAbstandsverstoss);
export default __webpack_public_path__ + "static/media/Verkehrsrecht_Abstandsverstoss.826b4ad18027b6d9988efd898644b2d7.svg";
export { ForwardRef as ReactComponent };